import { logAPI } from "../andyliticsApi";
const webTpaApiUrl = typeof window !== 'undefined' ? window.serverData.data.webTPAUrl : ''; // window is undefined during pre-render
import * as tools from "../../helpers/Tools";

export const getTaxFormsList = (token, MemberNumber) => {
    const url = encodeURI(tools.buildUrl(tools.hrAPIBaseURL(), 'members/documents/taxforms'));
    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            memid: MemberNumber
        })
    };
    var start = new Date();
    //debugger;
    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.TaxForms.getTaxFormsList", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.json());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.TaxForms.getTaxFormsList.Failure", start, url, err); return Promise.reject(err);
    });
};

export const getTaxFormUrl = (token, DocumentInfo, MemberNumber) => {
    //let baseUrl = tools.ciReplace(window.serverData.data.hpGatewayUrl, "WTPA", "HR");
    const url = encodeURI(tools.buildUrl(tools.hrAPIBaseURL(), 'members/documents/gettaxformurl'));
    const params = {
        method: 'post',
        headers: {
            'Authorization': 'bearer ' + token,
            "Content-type": "application/json"
        },
        body: JSON.stringify({
            memid: MemberNumber,
            documentName: DocumentInfo
        })
    };
    var start = new Date();

    return fetch(url, params).then(response => {
        logAPI("MBHWeb.Api.HealthPlanServices.TaxForms.getTaxFormUrl", start, url);
        if (response && response.status && response.status >= 200 && response.status < 300) {
            return Promise.resolve(response.blob());
        } else {
            return Promise.reject(response);
        }
    }).catch(err => {
        logAPI("MBHWeb.Api.HealthPlanServices.TaxForms.getTaxFormUrl.Failure", start, url, err); return Promise.reject(err);
    });
};